/* tslint:disable */
/* eslint-disable */
/**
 * crm-screener-api
 * crm-screener-api
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface BedPccMapping
 */
export interface BedPccMapping {
    /**
     * 
     */
    id?: string;
    /**
     * 
     */
    pcc_bed_id?: string;
}

/**
 * Check if a given object implements the BedPccMapping interface.
 */
export function instanceOfBedPccMapping(value: object): value is BedPccMapping {
    return true;
}

export function BedPccMappingFromJSON(json: any): BedPccMapping {
    return BedPccMappingFromJSONTyped(json, false);
}

export function BedPccMappingFromJSONTyped(json: any, ignoreDiscriminator: boolean): BedPccMapping {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'] == null ? undefined : json['id'],
        'pcc_bed_id': json['pcc_bed_id'] == null ? undefined : json['pcc_bed_id'],
    };
}

export function BedPccMappingToJSON(json: any): BedPccMapping {
    return BedPccMappingToJSONTyped(json, false);
}

export function BedPccMappingToJSONTyped(value?: BedPccMapping | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'id': value['id'],
        'pcc_bed_id': value['pcc_bed_id'],
    };
}

